/* Mercahome — wishlist (favoritos) via localStorage. */
(function () {
  var KEY = 'mrc_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('mrc:wishlist', { detail: { count: list.length } }));
  }
  function has(handle) { return read().some(function (p) { return p.handle === handle; }); }
  function toggle(data) {
    var list = read();
    var idx = list.findIndex(function (p) { return p.handle === data.handle; });
    if (idx > -1) list.splice(idx, 1);
    else list.push(data);
    write(list);
    return idx === -1;
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', has(btn.getAttribute('data-handle')) ? 'true' : 'false');
    });
    var bubble = document.querySelector('[data-wishlist-count]');
    if (bubble) {
      var n = read().length;
      bubble.textContent = n;
      bubble.hidden = n === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var data = {
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price')
    };
    var added = toggle(data);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
  });

  document.addEventListener('mrc:wishlist', syncButtons);

  // Render the favoritos page list if present.
  function renderPage() {
    var wrap = document.querySelector('[data-wishlist-list]');
    if (!wrap) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    wrap.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    list.forEach(function (p) {
      var card = document.createElement('article');
      card.className = 'mrc-pcard';
      card.innerHTML =
        '<a class="mrc-pcard__media" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="mrc-pcard__body">' +
          '<h3 class="mrc-pcard__title"><a href="' + p.url + '">' + (p.title || '') + '</a></h3>' +
          '<div class="mrc-pcard__spacer"></div>' +
          '<div class="mrc-pcard__price"><span class="price">' + (p.price || '') + '</span></div>' +
          '<button type="button" class="mrc-btn mrc-btn--outline mrc-pcard__cta" data-wishlist-toggle data-handle="' + p.handle + '" aria-pressed="true">Quitar de favoritos</button>' +
        '</div>';
      wrap.appendChild(card);
    });
  }

  function init() { syncButtons(); renderPage(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
